<template>
  <section
    id="arrival"
    class="mx-auto max-w-screen-xl py-8 lg:py-16 flex flex-col items-center"
  >
    <iframe
      title="Map showing the location of the Circus St. Ottilien"
      class="w-full h-[600px] px-16 lg:m-0 rounded-[1.5rem]"
      style="border: 0"
      loading="lazy"
      src="https://www.openstreetmap.org/export/embed.html?bbox=11.030688%2C48.087157%2C11.050688%2C48.107157&layer=mapnik&marker=48.097157%2C11.040688"
      referrerpolicy="no-referrer-when-downgrade"
    >
    </iframe>
  </section>
</template>
